import { makeObservable, observable, action, flow } from "mobx";
import { API } from "aws-amplify";
// import { getUsers } from "../../graphql/queries"; // Commented out - GraphQL removed
class FeatureStore {
  categories = [];
  features = [];
  status = 'idle';
  errorMessage = '';
  filteredFeatures = [];
  next = null;
  constructor() {
    makeObservable(this, {
      categories: observable,
      features: observable,
      status: observable,
      errorMessage: observable,
      filteredFeatures: observable,
      next: observable,
      fetchCategories: flow,
      fetchFeatures: flow,
      setFeatures: action,
      filterFeatures: action,
      addCategory: action,
      addFeature: action,
      removeFeature: action,
      updateFeature: action,
      setError: action,
    });
    // Initialize with default values
    this.features = [
      "Improve user experience",
      "Optimize workflows",
      "Enhance security",
      "Increase performance"
    ];
    this.filteredFeatures = [...this.features];
  }
  fetchCategories() {
    try {
      this.status = 'loading';
      this.categories = [
        'Category One', 'Category Two', 'Category Three', 'Category Four',
        'Category Five', 'Category Six', 'Category Seven', 'Category Eight',
      ];
      this.status = 'idle';
    } catch (error) {
      this.status = 'error';
      this.setError('Failed to load categories');
    }
  }
  *fetchFeatures(userId, customerId) {
    try {
      this.status = 'loading';
      // GraphQL removed - commented out
      // const response = yield API.graphql({
      //   query: getUsers,
      //   variables: { input: { customer: customerId, id: userId } },
      //   authMode: 'AMAZON_COGNITO_USER_POOLS'
      // });
      // if (!response?.data?.getUsers?.body) {
      //   throw new Error('Invalid response structure');
      // }
      // const userData = JSON.parse(response.data.getUsers.body);
      // // Ensure userData is an object and has features property
      // if (!userData || typeof userData !== 'object') {
      //   throw new Error('Invalid user data format');
      // }
      // this.setFeatures(userData.features || this.features);
      // this.next = userData.next || null;
      // TODO: Replace with REST API call
      this.status = 'idle';
    } catch (error) {
      this.status = 'error';
      this.setError('Failed to load features: ' + (error.message || 'Unknown error'));
      // Keep existing features in case of error
    }
  }
  setFeatures(features) {
    this.features = features;
    this.filteredFeatures = [...features];
  }
  filterFeatures(searchTerm) {
    if (!searchTerm) {
      this.filteredFeatures = [...this.features];
    } else {
      this.filteredFeatures = this.features.filter((feature) =>
        feature.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
  }
  addCategory(category) {
    if (category) {
      this.categories.push(category);
    }
  }
  addFeature(feature) {
    if (feature) {
      this.features.push(feature);
      this.filteredFeatures = [...this.features];
    }
  }
  removeFeature(index) {
    if (index >= 0 && index < this.features.length) {
      this.features.splice(index, 1);
      this.features = [...this.features];
      this.filteredFeatures = [...this.features];
    }
  }
  updateFeature(index, value) {
    if (index >= 0 && index < this.features.length) {
      this.features[index] = value;
      this.filteredFeatures = [...this.features];
    }
  }
  setError(message) {
    this.errorMessage = message;
    this.status = 'error';
  }
}
export default FeatureStore;